import { type IClientStorage, stringify } from "@medplum/core";

/**
 * Minimal in-memory IClientStorage for server-side contexts where the browser Storage API is unavailable.
 */
export class ServerSideStorage implements IClientStorage {
  private readonly map = new Map<string, string>();

  clear(): void {
    this.map.clear();
  }

  makeKey(key: string): string {
    return key;
  }

  getString(key: string): string | undefined {
    return this.map.get(key) ?? undefined;
  }

  setString(key: string, value: string | undefined): void {
    if (value) {
      this.map.set(key, value);
    } else {
      this.map.delete(key);
    }
  }

  getObject<T>(key: string): T | undefined {
    const str = this.getString(key);
    return str ? (JSON.parse(str) as T) : undefined;
  }

  setObject<T>(key: string, value: T): void {
    this.setString(key, value ? stringify(value) : undefined);
  }
}
